(function () {
  var VARIANT_ID = 47104381681815;

  function ensureTurkishCoffeeCheck() {
    var card = document.querySelector('#turkish-coffee-card');
    if (!card) return;

    if (!document.getElementById('turkish-coffee-addon-styles')) {
      var style = document.createElement('style');
      style.id = 'turkish-coffee-addon-styles';
      style.textContent =
        '#turkish-coffee-card #tc-check{' +
        'position:absolute;' +
        'right:12px;' +
        'top:50%;' +
        'transform:translateY(-50%);' +
        'display:flex;' +
        'align-items:center;' +
        'justify-content:center;' +
        'width:28px;' +
        'height:28px;' +
        'border-radius:50%;' +
        'background:rgba(var(--colors-button),1);' +
        'color:#fff;' +
        'font-size:14px;' +
        'line-height:1;' +
        'font-weight:700;' +
        'opacity:0;' +
        'visibility:hidden;' +
        'transition:opacity .15s ease,visibility .15s;' +
        'pointer-events:none;' +
        '}' +
        '#turkish-coffee-card.tc-selected #tc-check{' +
        'opacity:1;' +
        'visibility:visible;' +
        '}';
      document.head.appendChild(style);
    }

    if (window.getComputedStyle(card).position === 'static') {
      card.style.position = 'relative';
    }

    if (!card.querySelector('#tc-check')) {
      var check = document.createElement('span');
      check.id = 'tc-check';
      check.setAttribute('aria-hidden', 'true');
      check.textContent = '\u2713';
      card.appendChild(check);
    }
  }

  function init() {
    ensureTurkishCoffeeCheck();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', function (e) {
    var atcBtn = e.target.closest('button[name="add"]');
    if (!atcBtn) return;

    var card = document.querySelector('#turkish-coffee-card');
    if (!card || !card.classList.contains('tc-selected')) return;

    card.classList.remove('tc-selected');

    window.setTimeout(function () {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1 }] }),
      })
        .then(function (res) {
          return res.json().then(function () {
            if (!res.ok) return;
            fetch('/cart.js')
              .then(function (r) {
                return r.json();
              })
              .then(function (cart) {
                var bubble = document.querySelector('#cart-icon-bubble span');
                if (bubble) bubble.textContent = cart.item_count;

                if (window.Alpine && Alpine.store('xCartHelper')) {
                  Alpine.store('xCartHelper').currentItemCount = cart.item_count;
                }
                if (window.Alpine && Alpine.store('xMiniCart')) {
                  Alpine.store('xMiniCart').openCart();
                }
                document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
              });
          });
        })
        .catch(function () {});
    }, 800);
  });
})();
